
import { Store, Hotel, Truck, ShoppingBag, Image, Calendar } from "lucide-react";
import MyHomeLayout from "../MY_COMPONENTS/MyHomeLayout";
import MyHeaderLabel from "../components/MyHeaderLabel";
import { MdRoom } from "react-icons/md";
import MyDialogButton from "../MY_COMPONENTS/MyDialogButton";
import AdminManageAllOrders from "../ORDERS/AdminManageAllOrders";
import ShopAdminManageProducts from "../SHOP/admin/ShopAdminManageProducts";
import MyOrders from "../SHOP/user/MyOrders";
import AddProductForm from "../SHOP/forms/AddProductForm";
import AddVariantForm from "../SHOP/forms/AddVariantForm";
import { useAuth } from "../context/AuthContext";
import GazetteAnnouncementsPage from "@/SCRAPER/GazetteAnnouncements";
import { FaClock } from "react-icons/fa";
import { FaLeaf } from "react-icons/fa6";
import { BsPerson } from "react-icons/bs";






export default function HomeDashboard() {
  const {user} = useAuth();


  const isSuperAdmin = (): boolean => {
    return user?.is_superadmin || false;
  };


  const apps = [
 {
    key: "listings",
    title: "Products & Services",
    description: "Goods and services",
    icon: <ShoppingBag size={28} />,
    href: "/listings",
    enabled: true,
  //   component: <div className="flex flex-col w-full justify-between items-start">
  //   {user&&<MyDialogButton textButton label="My Listings" dialogContent={<MyOrders />} dialogHeader={<MyHeaderLabel label="MY ENTITIES"/>}/>}
  //   {isSuperAdmin()&& <>
  //  </>
  //   }
  //   </div>,
  },
    {
    key: "profiles",
    title: "Partner Finder",
    description: "Goods and services",
    icon: <BsPerson size={28} />,
    href: "/profiles",
    enabled: true,
  //   component: <div className="flex flex-col w-full justify-between items-start">
  //   {user&&<MyDialogButton textButton label="My Entities" dialogContent={<MyOrders />} dialogHeader={<MyHeaderLabel label="MY ENTITIES"/>}/>}
  //   {isSuperAdmin()&& <>
  //  </>
  //   }
  //   </div>,
  },
   {
    key: "templated",
    title: "Templates",
    description: "Discover Templates",
    icon: <ShoppingBag size={28} />,
    href: "/templates",
    enabled: true,
  //   component: <div className="flex flex-col w-full justify-between items-start">
  //   {user&&<MyDialogButton textButton label="My Scraper" dialogContent={<GazetteAnnouncementsPage />} dialogHeader={<MyHeaderLabel label="Gazette Announcements"/>}/>}
  //   {isSuperAdmin()&& <>
  //  </>
  //   }
  //   </div>,
  },

 {
    key: "scraper",
    title: "News & More",
    description: "Discover opportunities",
    icon: <ShoppingBag size={28} />,
    href: "/scraper",
    enabled: true,
  //   component: <div className="flex flex-col w-full justify-between items-start">
  //   {user&&<MyDialogButton textButton label="My Scraper" dialogContent={<GazetteAnnouncementsPage />} dialogHeader={<MyHeaderLabel label="Gazette Announcements"/>}/>}
  //   {isSuperAdmin()&& <>
  //  </>
  //   }
  //   </div>,
  },


  // {
  //   key: "bookings",
  //   title: "Bookings",
  //   description: "Goods and services",
  //   icon: <ShoppingBag size={28} />,
  //   href: "/bookings",
  //   enabled: true,
  //   component: <div className="flex flex-col w-full justify-between items-start">
  //   {user&&<MyDialogButton textButton label="My Bookings" dialogContent={<MyOrders />} dialogHeader={<MyHeaderLabel label="MY BOOKINGS"/>}/>}
  //   {isSuperAdmin()&& <>
  //   </>
  //   }
  //   </div>,
  // },

 {
    key: "clock",
    title: "Clock",
    description: "learn time",
    icon: <FaClock size={28} />,
    href: "/clock",
    enabled: true,
   
  },
 {
    key: "quiz",
    title: "Quiz",
    description: "learn time",
    icon: <FaLeaf size={28} />,
    href: "/quiz",
    enabled: true,
   
  },

  // {
  //   key: "seeders",
  //   title: "Seeders",
  //   description: "Seed",
  //   icon: <ShoppingBag size={28} />,
  //   href: "/seeder",
  //   enabled: true,
  // },

  {
    key: "admineroomcalendarpage",
    title: "Room Calendar",
    description: "Browse & manage media",
    icon: <Calendar size={28} />,
    href: "/admineroomcalendarpage",
    enabled: true,
  },
  {
    key: "imageconverter",
    title: "Image Converter",
    description: "Image Converter",
    icon: <Image size={28} />,
    href: "/imageconverter",
    enabled: true,
  },
  // {
  //   key: "roomfinder",
  //   title: "Room Finder",
  //   description: "Book hotels & stays",
  //   icon: <Hotel size={28} />,
  //   href: "/roomfinder",
  //   enabled: true,
  // },
  
 
  // {
  //   key: "rooms",
  //   title: "Rooms",
  //   description: "Book hotels & stays",
  //   icon: <Hotel size={28} />,
  //   href: "/rooms",
  //   enabled: true,
  // },
  // {
  //   key: "delivery",
  //   title: "Delivery",
  //   description: "Track & manage deliveries",
  //   icon: <Truck size={28} />,
  //   href: "/delivery",
  //   enabled: false,
  // },
  // {
  //   key: "myorders",
  //   title: "My Orders",
  //   description: "Track & manage my Orders",
  //   icon: <Truck size={28} />,
  //   href: "/myorders",
  //   enabled: true,
  // },
  // {
  //   key: "Orders",
  //   title: "Orders",
  //   description: "Track & manage Orders",
  //   icon: <Truck size={28} />,
  //   href: "/adminmanageorders",
  //   enabled: true,
  // },

  // {
  //   key: "admincreateproduct",
  //   title: "Create Product",
  //   description: "Admin Create Product",
  //   icon: <Store size={28} />,
  //   href: "/admincreateproduct",
  //   enabled: true,
  // },

  // {
  //   key: "manageproducts",
  //   title: "Manage Products",
  //   description: "Manage your business",
  //   icon: <Store size={28} />,
  //   href: "/adminmanageproducts",
  //   enabled: true,
  // },
  // {
  //   key: "managelistings",
  //   title: "Manage Listings",
  //   description: "Manage All Listings",
  //   icon: <Store size={28} />,
  //   href: "/adminmanagelistings",
  //   enabled: true,
  // },
  // {
  //   key: "manageprofiles",
  //   title: "Manage Profiles",
  //   description: "Manage All Profiles",
  //   icon: <Store size={28} />,
  //   href: "/adminmanageprofiles",
  //   enabled: true,
  // },
  // {
  //   key: "htmljson",
  //   title: "HTML ⇄ JSON Converter",
  //   description: "Design your HTML content",
  //   icon: <Store size={28} />,
  //   href: "/myhtmljson",
  //   enabled: true,
  // },
  // {
  //   key: "htmldesigner",
  //   title: "HTML Designer",
  //   description: "Design your HTML content",
  //   icon: <Store size={28} />,
  //   href: "/myhtmldesigner",
  //   enabled: true,
  // },
];

  return (
    <MyHomeLayout apps={apps}/>
  );
}
